import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private http: HttpClient) { }

  upload(fileData: { attachment: { fileName: string, content: string }}): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post(`${environment.BASE_URL}upload-files`, fileData, {
      headers,
      reportProgress: true,
      observe: 'events',
    });
  }

  deleteFile(fileData:any) {
    return this.http.post(`${environment.BASE_URL}delete-file`, fileData);
  }
  
  downloadFile(docId:string,type:string = 'download'): Observable<any> {
    return this.http.get(`${environment.BASE_URL}download-files?docId=${docId}&type=${type}`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  extractFileName(fileName: string) {
    const fileArray = fileName?.split('CCD_DOCS@2024');
    return fileArray?.[1].split('; mimetype')[0];
  }
}
